export default {

  methods: {

    apm_create_order() {
      this.credit_card_create_order();
    },

  },

};
